<script lang="ts">
	import { onDestroy, onMount } from 'svelte';
	import { type Container, type ISourceOptions, tsParticles } from '@tsparticles/engine';
	import { initialized } from './utils.js';

	interface Props {
		class?: string;
		style?: string;
		options?: ISourceOptions;
		url?: string;
		id?: string;
		onparticlesloaded?: (detail: { particles: Container | undefined }) => void;
	}

	let {
		class: cssClass = '',
		style = '',
		options = {},
		url = '',
		id = 'tsparticles',
		onparticlesloaded
	}: Props = $props();

	let canStart = false;
	let mounted = false;
	let oldId = id;

	function destroyOldContainer() {
		if (oldId) {
			const oldContainer = tsParticles.dom().find((c) => c.id.toString() === oldId);
			if (oldContainer) oldContainer.destroy();
		}
	}

	const unsub = initialized.subscribe((value) => {
		canStart = value;
		loadParticles();
	});

	onDestroy(() => {
		unsub();
		destroyOldContainer();
	});

	onMount(() => {
		mounted = true;
		void loadParticles();
	});

	async function loadParticles(): Promise<void> {
		destroyOldContainer();

		if (!canStart || !mounted) return;

		if (id) {
			const container = await tsParticles.load({ id, options, url });
			onparticlesloaded?.({ particles: container });
			oldId = id;
		} else {
			onparticlesloaded?.({ particles: undefined });
		}
	}

	// Replaces afterUpdate(loadParticles): re-runs whenever the relevant prop deps
	// change (post-mount; the onMount above does the initial load).
	$effect(() => {
		// Read reactive deps so the effect tracks them.
		void options;
		void url;
		void id;
		if (mounted) {
			void loadParticles();
		}
	});
</script>

<div {id} class={cssClass} {style}></div>
